/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { lazy } from "react";
import { Loadable } from "components/Loadable";

const Dashboard = Loadable(lazy(() => import("sections/dashboard/index")));

const dashboardRoutes = [
    {
        path: "/dashboard",
        element: <Dashboard />,
    },
];

export { dashboardRoutes };
